import { FC, ReactNode } from 'react';

import { styled } from '../theme';

export type BadgeColor = 'green' | 'red';

const Root = styled.span<{ badgeColor: BadgeColor }>(({ theme, badgeColor }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    flexShrink: 0,
    padding: '0 8px',
    borderRadius: 20,
    background: badgeColor === 'red' ? theme.color.red : theme.color.green1,
    color: theme.color.white,
    fontFamily: theme.typography.fontFamily,
    fontSize: 12,
    fontWeight: theme.typography.fontWeight.roman,
    lineHeight: '20px',
    whiteSpace: 'nowrap',
}));

interface Props {
    color?: BadgeColor;
    icon?: ReactNode;
    children: ReactNode;
    className?: string;
}

const Badge: FC<Props> = ({ color = 'green', icon, children, className }) => (
    <Root badgeColor={color} className={className}>
        {icon}
        {children}
    </Root>
);

export default Badge;
